import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import "react-h5-audio-player/lib/styles.css"

import CombinedProvider from "./src/context/CombinedProvider"

export const wrapRootElement = CombinedProvider
